export const ColumnVisibility = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.950684 1.6V14.4C0.950684 15.2836 1.6881 16 2.59774 16H15.6861C16.5958 16 17.3332 15.2836 17.3332 14.4V1.6C17.3332 0.716344 16.5958 0 15.6861 0H2.59774C1.6881 0 0.950684 0.716344 0.950684 1.6ZM2.40902 14.4V1.6C2.40902 1.57459 2.41745 1.54555 2.44924 1.51466C2.48178 1.48305 2.53155 1.45833 2.59774 1.45833H15.6861C15.7523 1.45833 15.8021 1.48305 15.8346 1.51466C15.8664 1.54555 15.8748 1.57459 15.8748 1.6V14.4C15.8748 14.4254 15.8664 14.4544 15.8346 14.4853C15.8021 14.5169 15.7523 14.5417 15.6861 14.5417H2.59774C2.53155 14.5417 2.48178 14.5169 2.44924 14.4853C2.41745 14.4544 2.40902 14.4254 2.40902 14.4Z"
			fill="currentColor"
		/>
		<path d="M5.66651 0.500005H7.33318V15.5H5.66651V0.500005Z" fill="currentColor" />
		<path d="M10.6665 0.500005H12.3332V15.5H10.6665V0.500005Z" fill="currentColor" />
	</svg>
);
